const throwIfUndefined = <T, K>(
  parent: T,
  selector: (t: T) => K | undefined
): K => {
  const value = selector(parent);

  if (value === undefined) {
    //eslint-disable-next-line no-console
    console.error(
      "Unexpected undefined value on",
      parent,
      "using selector",
      selector
    );
    throw new Error("Unexpected undefined value");
  } else {
    return value;
  }
};

export default throwIfUndefined;
